"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatMessageFiles = void 0;
var _ArtifactCard = require("../ArtifactCard");
var _useStoredImageUrl2 = require("../../hooks/use-stored-image-url");
var _chatMessageFiles = require("../../schemas/chat-message-files");
var _jsxRuntime = require("react/jsx-runtime");
var ChatMessageImage = function ChatMessageImage(_ref) {
  var sentImage = _ref.sentImage;
  var _useStoredImageUrl = (0, _useStoredImageUrl2.useStoredImageUrl)({
      storageUrl: sentImage.storage_url,
      fileName: sentImage.file_name
    }),
    imageUrl = _useStoredImageUrl.imageUrl,
    isUnavailable = _useStoredImageUrl.isUnavailable;
  if (isUnavailable) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    "data-testid": "chat-message-image-frame",
    className: "h-40 w-60",
    "data-sentry-component": "ChatMessageImage",
    "data-sentry-source-file": "ChatMessageFiles.tsx",
    children: imageUrl ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      src: imageUrl,
      alt: sentImage.file_name,
      className: "size-full object-contain object-right"
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "size-full animate-pulse rounded-lg bg-muted"
    })
  });
};
var ChatMessageFiles = exports.ChatMessageFiles = function ChatMessageFiles(_ref2) {
  var files = _ref2.files,
    renderMarkdown = _ref2.renderMarkdown,
    cardWidthPx = _ref2.cardWidthPx,
    cardBodyHeightPx = _ref2.cardBodyHeightPx;
  if (files.length === 0) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    "data-testid": "chat-message-files",
    className: "mb-2 flex flex-wrap items-end justify-end gap-2",
    "data-sentry-component": "ChatMessageFiles",
    "data-sentry-source-file": "ChatMessageFiles.tsx",
    children: files.map(function (sentFile) {
      return (0, _chatMessageFiles.isImageFileName)(sentFile.file_name) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(ChatMessageImage, {
        sentImage: sentFile
      }, sentFile.attachment_id) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_ArtifactCard.AttachmentCard, {
        attachment: sentFile,
        widthPx: cardWidthPx,
        bodyHeightPx: cardBodyHeightPx,
        renderMarkdown: renderMarkdown
      }, sentFile.attachment_id);
    })
  });
};